import { render, staticRenderFns } from "./roomItemData.vue?vue&type=template&id=12881fa6&scoped=true&"
import script from "./roomItemData.vue?vue&type=script&lang=js&"
export * from "./roomItemData.vue?vue&type=script&lang=js&"
import style0 from "./roomItemData.vue?vue&type=style&index=0&id=12881fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12881fa6",
  null
  
)

export default component.exports